var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1.07329","y1":"1.41879","x2":"23.0733","y2":"23.9521","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"23.0607","y1":"2.06066","x2":"1.06066","y2":"24.0607","strokeWidth":"2","key":1})]);
}

Close.defaultProps = {"width":"25px","height":"26px","viewBox":"0 0 25 26","fill":"none"};

module.exports = Close;

Close.default = Close;
